import {useMemo} from 'react';

function isString(value: unknown): value is string {
  return typeof value === 'string';
}

export default function useEntitySearchFilter<T extends {[key: string]: unknown}>(
  data: Array<T>,
  searchField: keyof T,
  search: string
): T[] {
  const refinedData = useMemo(() => {
    let filteredData = [...data];

    if (search && search.length > 0) {
      filteredData = data.filter(row => {
        // Remove accents and diacritics
        const cleanedSearch = search.normalize('NFD').replace(/[\u0300-\u036f]/gu, '');
        const reg = new RegExp(cleanedSearch, 'iu');

        if (searchField in row && isString(row[searchField])) {
          return (row[searchField] as string).search(reg) !== -1;
        }
        return true;
      });
    }

    return filteredData;
  }, [data, search]);

  return refinedData;
}
